"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require("babel-runtime/helpers/toConsumableArray");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _toArray2 = require("babel-runtime/helpers/toArray");

var _toArray3 = _interopRequireDefault(_toArray2);

var _defineProperty2 = require("babel-runtime/helpers/defineProperty");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _arguments = arguments;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _n = _n || {};

/* Query Selectors */
_n.qsa = function (cs, ps, map) {
  ps = ps || document;
  if (typeof ps == 'function') {
    map = ps;
    ps = document;
  }
  var all = _n.array(ps.querySelectorAll(cs));
  if (!!map) {
    return all.map(map);
  }
  return all;
};

_n.qs = function (cs, ps, map) {
  ps = ps || document;
  return _n.qsa(cs, ps, map)[0];
};

_n.xp = function (xpathToExecute) {
  var result = [];
  var nodesSnapshot = document.evaluate(xpathToExecute, document, null, XPathResult.ORDERED_NODE_SNAPSHOT_TYPE, null);
  for (var i = 0; i < nodesSnapshot.snapshotLength; i++) {
    result.push(nodesSnapshot.snapshotItem(i));
  }
  return result;
};

/* All in the family */
_n.parents = function (el, qs, is) {
  var ignore_self = is || false;
  if (el.matches("body") || el.matches("html")) return false;
  if (!el.matches(qs) && el.parentNode != null) {
    return _n.parents(el.parentNode, qs);
  } else if (el.matches(qs) && ignore_self) {
    return _n.parents(el.parentNode, qs);
  } else {
    return el;
  }
};

_n.siblings = function (el, qs) {
  var siblings = [];
  var sibling = el.parentNode.firstChild;
  for (; sibling; sibling = sibling.nextSibling) {
    if (sibling.nodeType !== 1 || sibling === el) continue;
    if (!!qs && !sibling.matches(qs)) continue;
    siblings.push(sibling);
  }
  return siblings;
};

_n.last = function (qs, p) {
  p = p || document;
  return _n.array(_n.qsa(qs, p)).reverse()[0];
};

_n.exists = function (qs, p) {
  try {
    return _n.qsa(qs, p).length > 0;
  } catch (err) {
    return false;
  }
  return false;
};

_n.remove = function (qs, p) {
  _n.qsa(qs, p).forEach(function (el) {
    el.remove();
  });
  return;
};

_n.index = function (el) {
  var children = el.parentNode.childNodes;
  var num = 0;
  for (var i = 0; i < children.length; i++) {
    if (children[i] == el) return num;
    if (children[i].nodeType == 1) num++;
  }
  return -1;
};

/* Reverse QuerySelector: creates queryselector from element */
_n.rqs = function (el, qs) {

  qs = qs || '';

  var selector = el.nodeName.toLowerCase();
  if (!!el.id) {
    selector += "#" + el.id;
  }
  if (el.classList.length) {
    selector += "." + _n.array(el.classList).join('.');
  }
  selector += ":nth-child(" + (_n.index(el) + 1) + ")";

  qs = selector + " " + qs;

  if (el.matches("body") || el.matches("html")) {
    return qs;
  } else {
    return _n.rqs(el.parentNode, qs);
  }
};

/* Dispatch Events */
_n.trigger = function (el, eventName, bubbles, cancelable) {
  var details = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  if (el === undefined || eventName === undefined) return false;
  if (bubbles === undefined) bubbles = true;
  if (cancelable === undefined) cancelable = true;
  var event = new CustomEvent(eventName, {
    detail: {
      message: el,
      time: new Date(),
      info: details
    },
    bubbles: bubbles,
    cancelable: cancelable
  });
  el.dispatchEvent(event);
};

_n.debounce = function (func) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;

  var timer = void 0;
  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    clearTimeout(timer);
    timer = setTimeout(function () {
      func.apply(undefined, args);
    }, timeout);
  };
};
window.addEventListener("resize", _n.debounce(function (e) {
  _n.trigger(window, 'resized');
}));

/* Arrays and Objects */
_n.array = function (val) {
  if (Array.isArray(val)) return val;
  if (NodeList.prototype.isPrototypeOf(val) || DOMTokenList.prototype.isPrototypeOf(val)) return Array.from(val);
  if (typeof val == 'string' || typeof val == 'number') return [val];
  if ((typeof val === "undefined" ? "undefined" : (0, _typeof3.default)(val)) == 'object') return [val];
  if (typeof val == 'undefined') return [];
};

_n.object = function (input, key) {
  var o = {};
  return input.reduce(function (obj, item) {
    return Object.assign({}, obj, (0, _defineProperty3.default)({}, item[key], item));
  }, o);
};

_n.copy = function (input) {
  return JSON.parse(JSON.stringify(input));
};

// _n.index = function ( item, collection ) {
//   return [].slice.call(collection).indexOf(item);
// }

_n.unique = function (input) {
  return input.filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
};

_n.flatten = function (array_of_arrays) {
  return array_of_arrays.reduce(function (flat, toFlatten) {
    return flat.concat(Array.isArray(toFlatten) ? _n.flatten(toFlatten) : toFlatten);
  }, []);
};

_n.set = function (array_of_arrays) {
  return _n.unique(_n.flatten(array_of_arrays));
};

_n.remove = function (values, array) {
  _n.array(values).forEach(function (value) {
    array.splice(array.indexOf(value), 1);
  });
  return array;
};

// deep array and object data mapping
_n.map = function (o, m) {
  var is_array = Array.isArray(o);
  var mapped_data = _n.array(o).map(function (data) {
    var mapped = {};
    for (var prop in m) {
      if (Array.isArray(m[prop])) mapped[prop] = _n.map(data[m[prop][0]], m[prop][1]);else if (m[prop].includes(".")) mapped[prop] = m[prop].split(".").reduce(function (ob, i) {
        return ob[i];
      }, data);else mapped[prop] = data[m[prop]];
    }
    return mapped;
  });
  if (!is_array) return mapped_data[0];
  return mapped_data;
};

// all possible combinations from multiple arrays
_n.combine = function (_ref) {
  var _ref2 = (0, _toArray3.default)(_ref),
      head = _ref2[0],
      _ref2$slice = (0, _toArray3.default)(_ref2.slice(1)),
      headTail = _ref2$slice[0],
      tailTail = _ref2$slice.slice(1);

  if (!headTail) return _n.array(head).map(function (i) {
    if (typeof i == 'array') i.reverse();
    return i;
  });

  var combined = headTail.reduce(function (acc, x) {
    return acc.concat(head.map(function (h) {
      return _n.array(x).concat(h);
    }));
  }, []);

  return _n.combine([combined].concat((0, _toConsumableArray3.default)(tailTail)));
};

_n.sum = function (a) {
  return _n.array(a).reduce(function (a, b) {
    return a + b;
  }, 0);
};

_n.sample = function (arr, size) {
  var shuffled = arr.slice(0),
      i = arr.length,
      min = i - size,
      temp,
      index;
  while (i-- > min) {
    index = Math.floor((i + 1) * Math.random());
    temp = shuffled[index];
    shuffled[index] = shuffled[i];
    shuffled[i] = temp;
  }
  return shuffled.slice(min);
};

_n.range = function (min, max, step) {

  step = step || 1;

  var arr = [];
  var d = 0;

  if (step % 1 != 0) d = step.toString().split(".")[1].length;

  for (var i = min || 0; i <= (max || 99); i += step || 1) {
    if (d) {
      arr.push(i.toFixed(d));
    } else {
      arr.push(i);
    }
  }
  return arr;
};

_n.empty = function (thing) {
  if (!!thing.nodeName) {
    if (thing.childElementCount == 0) {
      return true;
    }
    return false;
  }
  if (Array.isArray(thing) && thing.length == 0) return true;
  if ((typeof thing === "undefined" ? "undefined" : (0, _typeof3.default)(thing)) == 'object' && Object.keys(thing).length == 0) return true;
  return false;
};

_n.height = function (el) {
  el = typeof el === "string" ? document.querySelector(el) : el;

  var styles = window.getComputedStyle(el);
  var margin = parseFloat(styles["marginTop"]) + parseFloat(styles["marginBottom"]);

  return Math.ceil(el.offsetHeight + margin);
};

_n.inview = function (el, offset) {
  if (el.offsetParent === null) return false;
  offset = offset || 0;
  var bounding = el.getBoundingClientRect();
  var elTop = bounding.top + offset;
  var elBottom = bounding.bottom - offset;
  return elTop >= 0 && bounding.left >= 0 && elBottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.right <= (window.innerWidth + 1 || document.documentElement.clientWidth + 1);
};

_n.docheight = function () {
  var body = document.body;
  var html = document.documentElement;

  return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
};

_n.debounce = function (func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
        args = arguments;
    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

_n.random = function (a) {
  a = a || 15;
  if (Number.isInteger(a)) a = { length: a };
  var result = '';
  a.from = a.from || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  for (var i = 0; i < a.length; i++) {
    result += a.from.charAt(Math.floor(Math.random() * a.from.length));
  }
  return result;
};

_n.urlparams = {
  get: function get(p) {
    var paramstrings = document.location.href.split('?');
    if (paramstrings.length == 1) {
      if (!!p) return false;
      return [];
    }
    paramstrings[1] = paramstrings[1].split('#')[0];
    var params = {};
    paramstrings[1].split('&').forEach(function (part) {
      var v = part.split('=');
      if (v[0] && v[1]) params[decodeURIComponent(v[0])] = decodeURIComponent(v[1]);
    });
    if (!!p) {
      if (!!params[p]) return params[p];else return false;
    }
    return params;
  },
  set: function set(k, v, e) {
    var po = _n.urlparams.get();
    po[k] = v;
    return _n.urlparams.build(po, e);
  },
  join: function join(k, v, d, e) {
    if (!e && typeof d == "boolean") {
      e = d;
      d = ",";
    }
    d = d || ",";
    var po = _n.urlparams.get();
    if (!po[k]) {
      po[k] = v;
    } else {
      var a = po[k].split(d);
      a.push(v);
      po[k] = a.join(d);
    }
    return _n.urlparams.build(po, e);
  },
  unjoin: function unjoin(k, v, d, e) {
    if (!e && typeof d == "boolean") {
      e = d;
      d = ",";
    }
    d = d || ",";
    var po = _n.urlparams.get();
    if (!k in po) {
      return false;
    } else {
      po[k] = po[k].split(d).filter(function (p) {
        return p !== v;
      }).join(d);
      if (!po[k]) delete po[k];
    }
    return _n.urlparams.build(po, e);
  },
  jointoggle: function jointoggle(k, v, d, e) {
    if (!e && typeof d == "boolean") {
      e = d;
      d = ",";
    }
    d = d || ",";
    var po = _n.urlparams.get();
    if (!po[k] || !po[k].split(d).includes(v)) {
      return _n.urlparams.join(k, v, d, e);
    } else {
      return _n.urlparams.unjoin(k, v, d, e);
    }
  },
  toggle: function toggle(k, v, e) {
    var po = _n.urlparams.get();
    if (po[k] == v) delete po[k];else po[k] = v;
    return _n.urlparams.build(po, e);
  },
  unset: function unset(k, e) {
    var po = _n.urlparams.get();
    delete po[k];
    return _n.urlparams.build(po, e);
  },
  build: function build(o, e) {
    var ret = [];
    for (var d in o) {
      if (e) ret.push(encodeURIComponent(d) + "=" + encodeURIComponent(o[d]));else ret.push(d + "=" + o[d]);
    }return ret.join("&") + document.location.hash;
  }
};

_n.equal = function (value, other) {
  // Get the value type
  var type = Object.prototype.toString.call(value);

  // If the two objects are not the same type, return false
  if (type !== Object.prototype.toString.call(other)) return false;

  // If items are not an object or array, return false
  if (["[object Array]", "[object Object]"].indexOf(type) < 0) return false;

  // Compare the length of the length of the two items
  var valueLen = type === "[object Array]" ? value.length : Object.keys(value).length;
  var otherLen = type === "[object Array]" ? other.length : Object.keys(other).length;
  if (valueLen !== otherLen) return false;

  // Compare two items
  var compare = function compare(item1, item2) {
    // Get the object type
    var itemType = Object.prototype.toString.call(item1);

    // If an object or array, compare recursively
    if (["[object Array]", "[object Object]"].indexOf(itemType) >= 0) {
      if (!isEqual(item1, item2)) return false;
    }

    // Otherwise, do a simple comparison
    else {
        // If the two items are not the same type, return false
        if (itemType !== Object.prototype.toString.call(item2)) return false;

        // Else if it's a function, convert to a string and compare
        // Otherwise, just compare
        if (itemType === "[object Function]") {
          if (item1.toString() !== item2.toString()) return false;
        } else {
          if (item1 !== item2) return false;
        }
      }
  };

  // Compare properties
  if (type === "[object Array]") {
    for (var i = 0; i < valueLen; i++) {
      if (compare(value[i], other[i]) === false) return false;
    }
  } else {
    for (var key in value) {
      if (value.hasOwnProperty(key)) {
        if (compare(value[key], other[key]) === false) return false;
      }
    }
  }

  // If nothing failed, return true
  return true;
};

_n.fraction = function (value) {
  var donly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  var tolerance = 1.0E-6; // from how many decimals the number is rounded
  var h1 = 1;
  var h2 = 0;
  var k1 = 0;
  var k2 = 1;
  var negative = false;
  var i;

  if (parseInt(value) == value) {
    // if value is an integer, stop the script
    return value;
  } else if (value < 0) {
    negative = true;
    value = -value;
  }

  if (donly) {
    i = parseInt(value);
    value -= i;
  }

  var b = value;

  do {
    var a = Math.floor(b);
    var aux = h1;
    h1 = a * h1 + h2;
    h2 = aux;
    aux = k1;
    k1 = a * k1 + k2;
    k2 = aux;
    b = 1 / (b - a);
  } while (Math.abs(value - h1 / k1) > value * tolerance);

  return (negative ? "-" : '') + (donly & i != 0 ? i + ' ' : '') + (h1 == 0 ? '' : h1 + "/" + k1);
};

_n.sort = function (el, how, as, rev, order) {
  var sorted = [].concat((0, _toConsumableArray3.default)(el.children)).sort(function (a, b) {

    var type = !isNaN(eval("a." + how)) ? "numeric" : "alpha";
    if (!!as) type = as;

    if (type === "numeric") {
      return eval("a." + how) - eval("b." + how);
    } else {
      return eval("a." + how) > eval("b." + how) ? 1 : -1;
    }
  });

  if (!!order) {
    var values = sorted.map(function (el) {
      return eval("el." + how);
    });
    order = order.map(function (item) {
      if (values.indexOf(item) !== -1) values.splice(values.indexOf(item), 1);
      return item;
    }).concat(values);
    sorted = sorted.sort(function (a, b) {
      return order.indexOf(eval('a.' + how)) - order.indexOf(eval('b.' + how));
    });
  }

  if (rev) sorted = sorted.reverse();

  sorted.forEach(function (node) {
    return el.appendChild(node);
  });
};

_n.height = {};
_n.height.match = function (qs) {

  _n.qsa(qs).forEach(function (el) {
    el.style.removeProperty('height');
  });

  _n.qsa(qs).forEach(function (el) {
    var aligned = _n.qsa(qs).filter(function (o) {
      return o != el && o.offsetTop == el.offsetTop;
    });
    el.style.height = Math.max.apply(Math, (0, _toConsumableArray3.default)(aligned.map(function (a) {
      return a.scrollHeight;
    }))) + "px";
  });
};

_n.sortBy = function () {
  var props = _arguments;
  return function (obj1, obj2) {
    var i = 0,
        result = 0,
        numberOfProperties = props.length;
    while (result === 0 && i < numberOfProperties) {
      result = _n.sortBy(props[i])(obj1, obj2);
      i++;
    }
    return result;
  };
};

_n.debounce = function (callback, wait) {
  var timeoutId = null;
  return function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(function () {
      callback.apply(null, args);
    }, wait);
  };
};

_n.breakpoints = { sm: 640, md: 768, lg: 1024, xl: 1280, "2xl": 1536 };

String.prototype.handle = function () {
  var handle = this.replace(/%/g, '').replace("'", "").toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  try {
    handle = decodeURIComponent(this.replace(/%/g, '')).replace("'", "").toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  } catch (err) {}
  return handle;
};
String.prototype.capitalize = function () {
  str = this.toLowerCase();
  return str.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, function (s) {
    return s.toUpperCase();
  });
};

window._n = _n;

exports.default = _n;